import { HpClientQuestionSetState, HpDependentActionFunction } from '../types';
import { createDependentActionRunner } from './dependentActionRunner';
import { HpDynamicButtonClickDispatchFunction, HpDynamicButtonClickPayload } from './dynamicButtonClickActionTypes';
import { triggerFieldChangedEvent, triggerNavigationBarEvent } from './eventActions';

export function dynamicButtonClickAction(payload: HpDynamicButtonClickPayload): HpDependentActionFunction<unknown> {
  // payload should contain:
  //   questionId ... without group or key.
  //   question ..... if it is a group it will be the group question.
  const { getEvent, isNavigation, pageProps, question } = payload;
  const questionSet = pageProps as HpClientQuestionSetState;
  const { displayState, questionFormats, questionSetId } = questionSet;
  const { questionsUI } = displayState;
  const { questionId } = question;
  const ui = questionsUI[questionId]; // we need the 'ui' of the questionId including group (if applicable).
  const { dependentActions } = question.data;

  if (isNavigation) {
    triggerNavigationBarEvent({ getEvent, actionType: 'select', elementType: 'menu' });
  } else {
    triggerFieldChangedEvent({
      key: questionId,
      questionFormats,
      question,
      ui,
      getEvent,
      value: null
    });
  }

  const dispatchAction: HpDynamicButtonClickDispatchFunction = (dispatch) => {
    return dispatch({ type: 'DYNAMIC_BUTTON_CLICK', payload });
  };

  let action: HpDependentActionFunction<unknown> | undefined;
  if (dependentActions && dependentActions.length > 0) {
    action = createDependentActionRunner({
      questionSetId,
      dependentActions,
      question,
      questionSet,
      payload,
      dispatchAction
    });
  }

  if (!action) {
    action = dispatchAction;
  }

  return action;
}
